import { Animation, AnimationController } from '@ionic/angular';
import { AnimationBuilder } from '@angular/animations';
import { modalOpenAnimation } from "./modal-open.animation";

export function modalCloseAnimation(
  baseEl: any,
  opts?: any
): Animation {
  return modalOpenAnimation(baseEl, opts).direction('reverse');
}
